// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-menu-toogle-button {
  display: none;
}

.main-menu-dropdown {
  font-weight: 600;
  font-size: 16px;
}
.main-menu-dropdown a {
  color: white;
  line-height: 16px;
}
.main-menu-dropdown a:hover {
  color: white;
}

.main-menu-employee {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  background: #444258;
}
.main-menu-employee .employeeMenuNavItem:hover {
  opacity: 0.5;
  border: none;
  outline: none;
}
.main-menu-employee .btn.employeeMenuNavItem {
  border: none;
  outline: none;
  box-shadow: none;
}

.main-menu-col {
  display: flex;
  align-items: center;
}
.main-menu-col .mobile {
  display: none;
}
.main-menu-col .desktop {
  margin: 0 30px;
}
.main-menu-col .main-menu-mobile {
  display: none;
}

.main-menu-nav {
  width: 100%;
  position: relative;
  margin-left: 10px;
  height: 32px;
  align-items: center;
  justify-content: space-between;
  font-family: Montserrat;
  font-weight: 400;
  font-size: 14px;
  color: white;
  display: flex;
}
.main-menu-nav a {
  color: rgba(255, 255, 255, 0.9);
  padding: 5px;
  margin: 0 0.5rem;
}
.main-menu-nav a:hover {
  color: rgba(255, 255, 255, 0.55) !important;
}
.main-menu-nav input[type=radio] {
  position: absolute;
  top: -50px;
  visibility: hidden;
}
.main-menu-nav label {
  cursor: pointer;
  margin-left: 5px;
}
.main-menu-nav .menu-feed {
  position: relative;
}
.main-menu-nav .menu-feed::before {
  position: absolute;
  content: "";
  left: 0;
  bottom: -8px;
  width: 100%;
  height: 5px;
  background: white;
  border-radius: 0 0 3px 3px;
}
.main-menu-nav .bar-active-menu {
  height: 3px;
  position: absolute;
  bottom: -3px;
  background: rgba(106, 104, 170, 0);
  left: inherity;
  width: inherit;
  transition: all 0.5s ease;
}
.main-menu-nav .menu-notifications {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 20px;
}
.main-menu-nav .menu-notifications .badge {
  background: #dc3545;
  color: white;
}

.col-user-dropdown {
  display: flex;
  justify-content: center;
}
.col-user-dropdown svg {
  color: white;
}
.col-user-dropdown .dropdown-user {
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.teste {
  display: flex;
  justify-content: flex-end;
}

#menu-profile:checked ~ .bar-active-menu {
  left: 0;
  width: 66px;
  background: #7A6BE8;
}

#menu-moment:checked ~ .bar-active-menu {
  left: 67px;
  width: 109px;
  background: #7A6BE8;
}

#menu-networking:checked ~ .bar-active-menu {
  left: 177px;
  width: 132px;
  background: #7A6BE8;
}

#menu-company:checked ~ .bar-active-menu {
  left: 309px;
  width: 116px;
  background: #7A6BE8;
}

#menu-company-page:checked ~ .bar-active-menu {
  left: 425px;
  width: 128px;
  background: #7A6BE8;
}

@media screen and (max-width: 1140px) {
  .main-menu-toogle-button {
    display: flex;
  }
  .main-menu-toogle-button #dropdown-basic:after {
    visibility: hidden;
  }
  .main-menu-toogle-button svg {
    width: 30px;
    height: 20px;
  }
  .main-menu-nav {
    display: none;
  }
  .col-user-dropdown {
    display: none;
  }
}
@media screen and (max-width: 576px) {
  .col-user-dropdown {
    display: none;
  }
  .main-menu-toogle-button {
    display: none;
  }
  .main-menu {
    box-shadow: none;
    background: #7A6BE8;
  }
  .main-menu-col {
    width: 100%;
  }
  .main-menu-col .main-menu-nav {
    display: none;
  }
  .main-menu-col .mobile {
    display: block;
    margin: 0 15px;
  }
  .main-menu-col .desktop {
    display: none;
  }
  .main-menu-col .main-menu-mobile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .main-menu-col .main-menu-mobile a {
    margin: 0 8px;
  }
  .main-menu-col .main-menu-mobile a:first-child svg {
    fill: #7A6BE8;
    stroke: white;
  }
  .main-menu-col .main-menu-mobile a svg {
    height: 23px;
    width: 23px;
    fill: white;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/MainMenuEmployee/mainMenu.sass"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AACA;EACI,gBAAA;EACA,eAAA;AAEJ;AAAI;EACI,YAAA;EACA,iBAAA;AAER;AAAQ;EACI,YAAA;AAEZ;;AADA;EACI,mDAAA;EACA,mBAAA;AAIJ;AAFI;EACI,YAAA;EACA,YAAA;EACA,aAAA;AAIR;AAFI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;AAIR;;AAFA;EACI,aAAA;EACA,mBAAA;AAKJ;AAHI;EACI,aAAA;AAKR;AAHI;EACI,cAAA;AAKR;AAHI;EACI,aAAA;AAKR;;AAHA;EAEI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EAGA,mBAAA;EACA,8BAAA;EAEA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EAEA,aAAA;AAEJ;AAAI;EACI,+BAAA;EACA,YAAA;EACA,gBAAA;AAER;AAAQ;EACI,2CAAA;AAEZ;AAAI;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;AAER;AAAI;EACI,eAAA;EACA,gBAAA;AAER;AAAI;EACI,kBAAA;AAER;AAAQ;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,0BAAA;AAEZ;AAAI;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,cAAA;EACA,cAAA;EAKA,yBAAA;AACR;AACI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AACR;AACQ;EACI,mBAAA;EACA,YAAA;AACZ;;AACA;EACI,aAAA;EACA,uBAAA;AAEJ;AAAI;EACI,YAAA;AAER;AAAI;EACI,qCAAA;AAER;;AADA;EACI,aAAA;EACA,yBAAA;AAIJ;;AAFA;EACI,OAAA;EACA,WAAA;EACA,mBAAA;AAKJ;;AAHA;EACI,UAAA;EACA,YAAA;EACA,mBAAA;AAMJ;;AAJA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAOJ;;AALA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAQJ;;AANA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AASJ;;AAPA;EACI;IACI,aAAA;EAUN;EARM;IACI,kBAAA;EAUV;EARM;IACI,WAAA;IACA,YAAA;EAUV;EARE;IACI,aAAA;EAUN;EARE;IACI,aAAA;EAUN;AACF;AATA;EACI;IACI,aAAA;EAWN;EATE;IACI,aAAA;EAWN;EATE;IACI,gBAAA;IACA,mBAAA;EAWN;EATE;IACI,WAAA;EAWN;EATM;IACI,aAAA;EAWV;EATM;IACI,cAAA;IACA,cAAA;EAWV;EATM;IACI,aAAA;EAWV;EATM;IACI,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,WAAA;EAWV;EATU;IACI,aAAA;EAWd;EATkB;IACI,aAAA;IACA,aAAA;EAWtB;EATc;IACI,YAAA;IACA,WAAA;IACA,WAAA;EAWlB;AACF","sourcesContent":[".main-menu-toogle-button\n    display: none\n\n.main-menu-dropdown\n    font-weight: 600\n    font-size: 16px\n\n    & a\n        color: white\n        line-height: 16px\n\n        &:hover\n            color: white\n.main-menu-employee\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)\n    background: #444258\n\n    .employeeMenuNavItem:hover\n        opacity: 0.5\n        border: none\n        outline: none\n\n    .btn.employeeMenuNavItem\n        border: none\n        outline: none\n        box-shadow: none\n\n.main-menu-col\n    display: flex\n    align-items: center\n\n    & .mobile\n        display: none\n\n    & .desktop\n        margin: 0 30px\n\n    & .main-menu-mobile\n        display: none\n\n.main-menu-nav\n\n    width: 100%\n    position: relative\n    margin-left: 10px\n    height: 32px\n\n    display: flex\n    align-items: center\n    justify-content: space-between\n\n    font-family: Montserrat\n    font-weight: 400\n    font-size: 14px\n    color: white\n\n    display: flex\n\n    & a\n        color: rgba(255,255,255,.9)\n        padding: 5px\n        margin: 0 .5rem\n\n        &:hover\n            color: rgba(255,255,255,.55) !important\n\n    & input[type=radio]\n        position: absolute\n        top: -50px\n        visibility: hidden\n\n    & label\n        cursor: pointer\n        margin-left: 5px\n\n    .menu-feed\n        position: relative\n\n        &::before\n            position: absolute\n            content: ''\n            left: 0\n            bottom: -8px\n            width: 100%\n            height: 5px\n            background: white\n            border-radius: 0 0 3px 3px\n\n    & .bar-active-menu\n        height: 3px\n        position: absolute\n        bottom: -3px\n        background: #6a68aa00\n        left: inherity\n        width: inherit\n\n        -webkit-transition: all .5s ease\n        -moz-transition: all .5s ease\n        -o-transition: all .5s ease\n        transition: all .5s ease\n\n    & .menu-notifications\n        display: flex\n        align-items: center\n        justify-content: center\n        margin: 0 20px\n\n        & .badge\n            background: #dc3545\n            color: white\n\n.col-user-dropdown\n    display: flex\n    justify-content: center\n\n    & svg\n        color: white\n\n    & .dropdown-user\n        border: 1px solid rgba(0,0,0,.15)\n.teste\n    display: flex\n    justify-content: flex-end\n\n#menu-profile:checked ~ .bar-active-menu\n    left: 0\n    width: 66px\n    background: #7A6BE8\n\n#menu-moment:checked ~ .bar-active-menu\n    left: 67px\n    width: 109px\n    background: #7A6BE8\n\n#menu-networking:checked ~ .bar-active-menu\n    left: 177px\n    width: 132px\n    background: #7A6BE8\n\n#menu-company:checked ~ .bar-active-menu\n    left: 309px\n    width: 116px\n    background: #7A6BE8\n\n#menu-company-page:checked ~ .bar-active-menu\n    left: 425px\n    width: 128px\n    background: #7A6BE8\n\n@media screen and (max-width: '1140px')\n    .main-menu-toogle-button\n        display: flex\n\n        & #dropdown-basic:after\n            visibility: hidden\n\n        & svg\n            width: 30px\n            height: 20px\n\n    .main-menu-nav\n        display: none\n\n    .col-user-dropdown\n        display: none\n\n@media screen and (max-width: '576px')\n    .col-user-dropdown\n        display: none\n\n    .main-menu-toogle-button\n        display: none\n\n    .main-menu\n        box-shadow: none\n        background: #7A6BE8\n\n    .main-menu-col\n        width: 100%\n\n        & .main-menu-nav\n            display: none\n\n        & .mobile\n            display: block\n            margin: 0 15px\n\n        & .desktop\n            display: none\n\n        & .main-menu-mobile\n            display: flex\n            align-items: center\n            justify-content: space-between\n            width: 100%\n\n            & a\n                margin: 0 8px\n                &:first-child\n                    & svg\n                        fill: #7A6BE8\n                        stroke: white\n\n                & svg\n                    height: 23px\n                    width: 23px\n                    fill: white\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
